import { render, staticRenderFns } from "./Further-Review.vue?vue&type=template&id=35e8d8b0&"
import script from "./Further-Review.vue?vue&type=script&lang=js&"
export * from "./Further-Review.vue?vue&type=script&lang=js&"
import style0 from "./Further-Review.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports